import { render } from "./BuscaRapida.vue?vue&type=template&id=6ed7d1bc&scoped=true&ts=true"
import script from "./BuscaRapida.vue?vue&type=script&lang=ts"
export * from "./BuscaRapida.vue?vue&type=script&lang=ts"

import "./BuscaRapida.vue?vue&type=style&index=0&id=6ed7d1bc&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ed7d1bc"]])

export default __exports__